import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { CommunicationDisplay, Colors, VoicemailDrop } from 'typings';
import VoicemailIcon from '@material-ui/icons/Voicemail';

interface VoicemailDropProps extends CommunicationDisplay {
  data: VoicemailDrop;
  children: React.ReactNode;
  caption?: React.ReactElement;
}

const useStyles = makeStyles((theme: Theme) => ({
  innerWrapper: {
    flexDirection: 'column',
    width: '100%',
  },
  text: {
    padding: theme.spacing(0, 1),
    borderBottom: `2px solid ${Colors.MEDIUM_GRAY}`,
    textAlign: 'right',
  },
  caption: {
    fontWeight: 500,
    padding: theme.spacing(0, 1),
    color: theme.palette.grey['500'],
  },
  icon: {
    fill: 'white',
    backgroundColor: Colors.MEDIUM_GRAY,
    display: 'inline-flex',
    width: theme.spacing(4),
    height: theme.spacing(4),
    padding: theme.spacing(0.5),
    borderRadius: '50%',
    boxShadow: `0 0 2px ${Colors.LIGHT_GRAY}`,
  },
}));

const VoicemailDropContent = ({
  data,
  children,
  caption,
}: React.PropsWithChildren<VoicemailDropProps>) => {
  const classes = useStyles({ data, children });

  return (
    <>
      <Box className={classes.innerWrapper}>
        <Typography variant="body2" className={classes.text}>
          {data.name}
        </Typography>
        {caption}
      </Box>
      <VoicemailIcon className={classes.icon} />
    </>
  );
};

export default VoicemailDropContent;
